var map = {
	"./angular.svg": 5537,
	"./firebase.svg": 7079,
	"./github.svg": 8866,
	"./html.svg": 7218,
	"./java.svg": 6522,
	"./javascript.svg": 3173,
	"./link.svg": 7966,
	"./node.svg": 9410,
	"./pygame.svg": 4101,
	"./python.svg": 946,
	"./react.svg": 9978,
	"./redux.svg": 9522,
	"./scss.svg": 4524,
	"./typescript.svg": 3328,
	"./vue.svg": 5741,
	"./wordpress.svg": 6669
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8091;